import React, { Component } from 'react';
import { withRouter } from '../navigation/withNavigation';
import { urlMap } from '../../utils';
import { applyThemePref } from '../../utils/theme';

const BOOTSTRAP_TIMEOUT_MS = 15000;

const FIG_MAIN_PATH = 'M106.31671,99.4230762 C106.22671,96.4230762 105.54671,84.5130762 97.74671,74.1530762 C94.95671,70.4530762 91.57671,67.3730762 87.14671,63.3330762 C80.53671,57.3330762 79.43671,57.5330762 74.49671,52.7430762 C71.55671,49.8930762 65.83671,44.4230762 62.77671,37.5530762 C60.9076788,33.1271393 59.9944193,28.3563804 60.09671,23.5530762 L45.67671,23.5530762 C45.67671,24.1830762 45.67671,24.8930762 45.59671,25.6730762 C45.5506511,26.9718097 45.433811,28.2670656 45.24671,29.5530762 C44.9515643,31.2977592 44.4860021,33.0092863 43.85671,34.6630762 C42.4463509,38.52669 40.4201713,42.1366666 37.85671,45.3530762 C34.8777658,49.0485148 31.3975115,52.309991 27.51671,55.0430762 C24.30671,57.4930762 13.05671,66.1030762 6.80671003,76.1330762 C2.61929187,83.054578 0.284353426,90.9375782 0.0267100292,99.0230762 C-0.663289971,119.113076 12.22671,132.753076 14.21671,134.793076 C28.30671,149.243076 46.28671,149.883076 51.64671,149.993076 L53.16671,149.993076 C60.49671,149.933076 79.08671,148.383076 92.94671,133.313076 C95.70671,130.353076 106.88671,117.803076 106.31671,99.4230762 Z';
const FIG_STEM_PATH = 'M45.67671,23.6830762 L45.67671,23.2730762 C45.67671,20.5930762 45.61671,19.7430762 45.58671,19.4130762 C45.50671,18.4730762 45.38671,17.6630762 45.27671,17.0130762 C45.1532837,16.5340442 44.9166522,16.0916463 44.58671,15.7230762 C43.9746309,15.1819448 43.2161285,14.8340079 42.40671,14.7230762 C41.6557056,14.5184361 40.884326,14.3976984 40.10671,14.3630762 C39.39671,14.3630762 39.21671,14.3630762 38.56671,14.3630762 C37.9880182,14.2979644 37.4180483,14.1705593 36.86671,13.9830762 C35.716545,13.5750746 34.685698,12.8878433 33.86671,11.9830762 C32.6085221,10.3652584 32.086191,8.29407058 32.42671,6.2730762 C32.7084088,3.84921034 34.3278877,1.78910944 36.61671,0.943076204 C37.6048791,0.677631087 38.6062445,0.464006464 39.61671,0.303076204 C41.6492286,0.0455093171 43.6991743,-0.0481260465 45.74671,0.0230762039 C48.91671,0.0230762039 49.80671,0.153076204 50.74671,0.433076204 C51.5266825,0.669197055 52.2805737,0.984156075 52.99671,1.3730762 C54.7025854,2.3227228 56.177706,3.63735579 57.31671,5.2230762 C58.3529479,6.57007661 59.1418524,8.0903261 59.64671,9.7130762 C59.9120489,10.6512247 60.089481,11.6120364 60.17671,12.5830762 C60.3877782,14.6433571 60.4112078,16.718555 60.24671,18.7830762 C60.18671,20.0130762 60.11671,21.6730762 60.08671,23.6830762';
const FIG_STEM_SHADOW_PATH = 'M55.48671,23.6830762 C55.48671,23.3130762 55.48671,22.9130762 55.48671,22.4930762 C55.48671,20.2130762 55.48671,19.0630762 55.17671,18.2130762 C54.4854638,16.67187 53.2499048,15.4398716 51.70671,14.7530762 C49.28671,13.5830762 48.33671,14.7530762 45.98671,13.9030762 C43.1742499,12.8696635 41.1371024,10.4006254 40.65671,7.4430762 C40.4174562,5.36771335 41.0926918,3.29090772 42.50671,1.7530762 C43.0242846,1.17913302 43.6584142,0.722286894 44.36671,0.413076204 C45.36671,-0.0469237961 46.36671,0.00307620386 48.30671,0.0930762039 C49.2234535,0.091542553 50.1369296,0.202368698 51.02671,0.423076204 C51.899816,0.683629401 52.7339475,1.06033399 53.50671,1.5430762 C54.3227244,2.01216301 55.0898628,2.56155471 55.79671,3.1830762 C57.2562257,4.51442856 58.4270369,6.131101 59.23671,7.9330762 C60.1734498,10.0939115 60.643693,12.4280895 60.61671,14.7830762 C60.66671,16.9330762 60.34671,17.3830762 60.17671,20.7830762 C60.11671,21.8430762 60.09671,22.7830762 60.09671,23.6330762';
const FIG_LEAF_PATH = 'M53.16671,34.5630762 C51.0567142,39.8145712 48.0409152,44.6547425 44.25671,48.8630762 C38.43671,55.2730762 33.99671,56.4130762 27.65671,62.2830762 C25.65671,64.1030762 18.65671,70.9130762 14.65671,79.9430762 C6.14671003,99.2830762 16.12671,119.443076 16.76671,120.683076 C27.82671,142.213076 50.44671,146.743076 53.19671,147.243076';
const FIG_WHITE_SPOT_1 = 'M17.94671,119.093076 C18.3230455,120.115208 17.8833532,121.257949 16.9189415,121.764202 C15.9545298,122.270455 14.7642562,121.983339 14.13671,121.093076 L12.16671,117.233076 C11.9869429,116.288896 12.4295552,115.335268 13.26671,114.863076 C14.2580134,114.350601 15.4747799,114.634654 16.13671,115.533076 L17.94671,119.093076 Z';
const FIG_WHITE_SPOT_2 = 'M38.79671,143.893076 C31.0436053,140.725992 24.3380818,135.441277 19.44671,128.643076 C18.9675665,127.922089 18.9675665,126.984063 19.44671,126.263076 C19.8058758,125.785628 20.3514059,125.483768 20.94671,125.433076 C21.6115275,125.411649 22.2506363,125.6908 22.68671,126.193076 C23.6274465,127.377354 24.628783,128.512202 25.68671,129.593076 C27.2491129,131.186483 28.919759,132.670017 30.68671,134.033076 C33.5484483,136.223853 36.6240414,138.120134 39.86671,139.693076 C40.7911543,140.161255 41.2687404,141.206704 41.0174158,142.212003 C40.7660912,143.217301 39.8527158,143.91501 38.81671,143.893076 L38.79671,143.893076 Z';

function FigProgressLoader({ progress = 0 }) {
  const safeProgress = Math.max(0, Math.min(1, progress));
  const fillHeight = 151 * safeProgress;
  const fillY = 151 - fillHeight;
  const progressPercent = `${Math.round(safeProgress * 100)}%`;

  return (
    <div className="onboarding-fig-loader">
      <svg width="86" height="120" viewBox="0 0 108 151" role="img" aria-label="Preparing writer session">
        <defs>
          <clipPath id="fig-progress-clip">
            <rect x="0" y={fillY} width="108" height={fillHeight} />
          </clipPath>
        </defs>

        <g transform="translate(0.833290, 0.976924)" fillRule="nonzero">
          <path d={FIG_MAIN_PATH} fill="#b66bcf" />
          <path d={FIG_STEM_PATH} fill="#4a2d86" />
          <path d={FIG_STEM_SHADOW_PATH} fill="#3a3f8f" />
          <path d={FIG_LEAF_PATH} fill="#cd92dd" />

          <g clipPath="url(#fig-progress-clip)">
            <path d={FIG_MAIN_PATH} fill="#5c157f" />
            <path d={FIG_STEM_PATH} fill="#200950" />
            <path d={FIG_STEM_SHADOW_PATH} fill="#1d2f6a" />
            <path d={FIG_LEAF_PATH} fill="#7b239f" />
          </g>

          <path d={FIG_WHITE_SPOT_1} fill="#ffffff" />
          <path d={FIG_WHITE_SPOT_2} fill="#ffffff" />
        </g>
      </svg>

      <div className="onboarding-progress-track">
        <div
          className="onboarding-progress-fill"
          style={{ '--onboarding-progress': progressPercent }}
        />
      </div>
    </div>
  );
}

function generateGuid() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

class DraftBootstrap extends Component {
  inFlightGuid = null;
  progressTimer = null;

  state = {
    guid: null,
    loading: true,
    error: null,
    bootstrapUrl: null,
    visualProgress: 0.06,
    themePref: 'light',
  };

  async componentDidMount() {
    let pref = 'light';
    try {
      const cached = localStorage.getItem('themePref');
      pref = cached || 'light';
      if (!cached) localStorage.setItem('themePref', pref);
    } catch {}

    applyThemePref(pref);
    this.setState({ themePref: pref });
    await this.bootstrap();
  }

  onThemeChange = (pref) => {
    this.setState({ themePref: pref });
    applyThemePref(pref);
  };

  componentWillUnmount() {
    this.stopVisualProgress();
  }

  async componentDidUpdate(prevProps) {
    const prevGuid = prevProps.params?.guid;
    const currGuid = this.props.params?.guid;
    if (prevGuid !== currGuid) {
      await this.bootstrap();
    }
  }

  async bootstrap() {
    const { navigate, params, location } = this.props;

    const search = new URLSearchParams(location?.search || '');
    const sourceProjectId = search.get('sourceProjectId') || '';
    const sourceChapterId = search.get('sourceChapterId') || '';

    const routeGuid = params?.guid;
    const guid = routeGuid || generateGuid();

    if (this.inFlightGuid === guid) return;

    const bootstrapUrl = urlMap.bootstrapOnboardingDraft(guid, sourceProjectId, sourceChapterId);

    this.setState({ guid, loading: true, error: null, bootstrapUrl, visualProgress: 0.06 });
    this.startVisualProgress();

    this.inFlightGuid = guid;

    if (!routeGuid) {
      const nextSearch = search.toString();
      navigate(`/on-boarding/${guid}${nextSearch ? `?${nextSearch}` : ''}`, { replace: true });
    }

    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), BOOTSTRAP_TIMEOUT_MS);

      const res = await fetch(bootstrapUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      if (!res.ok) {
        throw new Error(`Bootstrap failed (${res.status})`);
      }

      const draft = await res.json();
      this.stopVisualProgress();
      navigate(`/on-boarding/${draft?.guid || guid}/writer${location?.search || ''}`, { replace: true });
    } catch (err) {
      this.stopVisualProgress();
      const message = err?.name === 'AbortError'
        ? `Bootstrap timed out after ${Math.round(BOOTSTRAP_TIMEOUT_MS / 1000)}s`
        : (err?.message || 'Failed to start onboarding session.');

      this.setState({
        loading: false,
        error: message,
      });
    } finally {
      this.inFlightGuid = null;
    }
  }

  startVisualProgress() {
    if (this.progressTimer) clearInterval(this.progressTimer);
    this.progressTimer = setInterval(() => {
      this.setState((prev) => {
        if (!prev.loading) return prev;
        if (prev.visualProgress >= 0.92) return prev;
        const bump = Math.max(0.01, (0.95 - prev.visualProgress) * 0.14);
        return { visualProgress: Math.min(0.92, prev.visualProgress + bump) };
      });
    }, 120);
  }

  stopVisualProgress() {
    if (this.progressTimer) {
      clearInterval(this.progressTimer);
      this.progressTimer = null;
    }
  }

  render() {
    const { guid, loading, error, bootstrapUrl, visualProgress, themePref } = this.state;

    return (
      <div className="home onboarding-bootstrap-page">
        <div className="onboarding-header-row">
          <h2>creating your storyclub writing session</h2>
          <div className="onboarding-theme-switch-wrap">
            <span className="onboarding-theme-switch-label">light</span>
            <label className="onboarding-theme-switch" aria-label="Toggle dark mode">
              <input
                type="checkbox"
                checked={themePref === 'dark'}
                onChange={(e) => this.onThemeChange(e.target.checked ? 'dark' : 'light')}
              />
              <span className="onboarding-theme-switch-slider" />
            </label>
            <span className="onboarding-theme-switch-label">dark</span>
          </div>
        </div>

        {loading && (
          <div className="onboarding-bootstrap-loading">
            <FigProgressLoader progress={visualProgress} />
            <p className="onboarding-bootstrap-progress-text">
              creating your storyclub writing session... {Math.max(6, Math.round(visualProgress * 100))}%
            </p>
          </div>
        )}

        {error && (
          <div className="onboarding-alert">
            <div>{error}</div>
            {bootstrapUrl && <div className="onboarding-bootstrap-request">Request: {bootstrapUrl}</div>}
          </div>
        )}

        {!loading && !error && guid && (
          <>
            <p>Your onboarding session is ready. Redirecting to writer mode...</p>
          </>
        )}
      </div>
    );
  }
}

export default withRouter(DraftBootstrap);
